import React from "react";

import RegisterPageLayer from "../components/RegisterPageLayer";

const RegisterPage = () => {
  return (
    <>

        {/* Register Page Layer */}
        <RegisterPageLayer />

    </>
  );
};

export default RegisterPage; 
